import type { ComponentType } from 'react';
import { memo } from 'react';

import type { OverridableComponent, OverridableTypeMap } from '../types';

export function createComponent<M extends OverridableTypeMap>(render: ComponentType<any>) {
  return memo(render) as unknown as OverridableComponent<M>;
}
